import React from 'react';
import { translate } from 'react-i18next';
import {Card, CardText} from 'material-ui/Card';
import {List, ListItem} from 'material-ui/List';
import FlatButton from 'material-ui/FlatButton';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import ProductCreate from './ProductCreate';
import CategoryCreate from './CategoryCreate';
import ProductAvatar from '../Product/ProductAvatar';
import Previous from 'material-ui/svg-icons/navigation/chevron-left';
import Next from 'material-ui/svg-icons/navigation/chevron-right';
import FirstPage from 'material-ui/svg-icons/navigation/first-page';
import LastPage from 'material-ui/svg-icons/navigation/last-page';
import IconButton from 'material-ui/IconButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import IconMenu from 'material-ui/IconMenu';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import { Link } from 'react-router-dom';

class Portfolio extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      categories: [],
      selectValue: 0,
      loadingIndicator: 'flex',
      productsPerPage: 15,
      firstPage: true,
      lastPage: false,
      dialogCreateOpen: false,
      dialogCategoryCreateOpen: false,
      category: ''
    };
  }
  componentDidMount = () => {
    const {firebase} = this.props;
    let index = 0;
    const currentCategories = [];
    this.portfolioRef = firebase.database().ref('portfolio/categories').orderByValue();
    this.portfolioRef.once('value', (categories) => {
      categories.forEach((data) => {
        const category = {
          key: data.key,
          index,
          name: data.val()
        };
        currentCategories.push(category);
        index += 1;
      });
      if (currentCategories.length === 0) {
        this.setState({lastPage: true});
        return;
      }
      this.setState({categories: currentCategories, category: currentCategories[0].key});
      this.getFirstProducts(currentCategories[0].key);
    });
  }

  handleCategoryChange = (event, index, value) => {
    this.setState({selectValue: value, firstProduct: undefined, lastProduct: undefined, category: this.state.categories[value].key});
    this.getFirstProducts(this.state.categories[value].key);
  }

  getFirstProducts = (key) => {
    const {firebase} = this.props;

    firebase.database().ref('portfolio/' + key + '/products/')
      .orderByChild('name')
      .limitToFirst(this.state.productsPerPage)
      .once('value', (queryProducts) => {
        this.updateFirstProducts(queryProducts);
      });
  }
  getLastProducts = () => {
    const {firebase} = this.props;

    firebase.database().ref('portfolio/' + this.state.categories[this.state.selectValue].key + '/products/')
      .orderByChild('name')
      .limitToLast(this.state.productsPerPage)
      .once('value', (queryProducts) => {
        this.updateProducts(queryProducts);
      });
    this.setState({lastPage: true, firstPage: false});
  }
  getNextProducts = () => {
    const {firebase} = this.props;

    firebase.database().ref('portfolio/' + this.state.categories[this.state.selectValue].key + '/products/')
      .orderByChild('name')
      .limitToFirst(this.state.productsPerPage)
      .startAt(this.state.products[this.state.products.length - 1].name + 'a')
      .once('value', (queryProducts) => {
        this.updateProducts(queryProducts);
      });
    this.setState({firstPage: false});
  }
  getPreviousProducts = () => {
    const {firebase} = this.props;

    firebase.database().ref('portfolio/' + this.state.categories[this.state.selectValue].key + '/products/')
      .orderByChild('name')
      .limitToLast(this.state.productsPerPage)
      .endAt(this.state.products[0].name.slice(0, -1))
      .once('value', (queryProducts) => {
        this.updateProducts(queryProducts);
      });
    this.setState({lastPage: false});
  }

  updateFirstProducts = (queryProducts) => {
    const {firebase} = this.props;

    const products = [];
    queryProducts.forEach((data) => {
      const product = {
        key: data.key,
        ...data.val()
      };
      products.push(product);
    });
    if (products.length > 0) {
      this.setState({products, firstProduct: products[0].key, firstPage: true});
    } else {
      this.setState({products, firstPage: true, lastPage: true});
      return;
    }

    firebase.database().ref('portfolio/' + this.state.categories[this.state.selectValue].key + '/products/')
      .orderByChild('name')
      .limitToLast(1)
      .once('value', (product) => {
        product.forEach((lastProduct) => {
          if (products[products.length - 1].key === lastProduct.key) {
            this.setState({lastPage: true});
          } else {
            this.setState({lastPage: false});
          }
          this.setState({lastProduct: lastProduct.key});
        });
      });

    this.getPictures(products);
  }

  updateProducts = (queryProducts) => {
    const products = [];
    queryProducts.forEach((data) => {
      const product = {
        key: data.key,
        ...data.val()
      };
      products.push(product);
    });
    this.setState({products});
    if (products[0].key === this.state.firstProduct) {
      this.setState({firstPage: true});
    }
    if (products[products.length - 1].key === this.state.lastProduct) {
      this.setState({lastPage: true});
    }
    this.getPictures(products);
  }

  getPictures = (products) => {
    const {firebase} = this.props;
    products.forEach((product) => {
      if (product.picture) {
        firebase.storage().ref(product.picture).getDownloadURL().then((url) => {
          product.pictureUrl = url;
          const currentProducts = this.state.products.slice();
          this.setState({products: currentProducts});
        });
      }
    });
  }

  handleCreateOpen = () => this.setState({dialogCreateOpen: true});
  handleCreateClose = () => this.setState({dialogCreateOpen: false});

  handleCategoryCreateOpen = () => this.setState({dialogCategoryCreateOpen: true});
  handleCategoryCreateClose = (key) => {
    if (key) {
      const {firebase} = this.props;
      let index = 0;
      var value = 0;
      const currentCategories = [];
      this.portfolioRef = firebase.database().ref('portfolio/categories').orderByValue();
      this.portfolioRef.once('value', (categories) => {
        categories.forEach((data) => {
          const category = {
            key: data.key,
            index,
            name: data.val()
          };
          if (key === data.key) {
            value = index;
          }
          currentCategories.push(category);
          index += 1;
        });
        this.setState({categories: currentCategories, category: key, selectValue: value});
        this.getFirstProducts(key);
      });
    }
    this.setState({dialogCategoryCreateOpen: false});
  }

  render() {
    const {t} = this.props;

    const categories = this.state.categories.map((category) => (
      <MenuItem key={category.key} value={category.index} primaryText={category.name} />
    ));

    const products = this.state.products.map((product) => (
      <ListItem key={product.key}
        primaryText={product.name}
        containerElement={(<Link to={`portfolio/${this.state.category}/${product.key}`} />)}
        leftAvatar={<ProductAvatar src={product.pictureUrl} name={product.name}/>}
        />
    ));

    return (
        <Card className='cardStyle'>
          <Toolbar>
            <ToolbarGroup>
              <ToolbarTitle text={t('portfolio')} />
            </ToolbarGroup>
            <ToolbarGroup lastChild={true}>
              <FlatButton label={t('product.new')} primary={true} onTouchTap={this.handleCreateOpen}/>
                <IconMenu
                iconButtonElement={<IconButton touch={true}><MoreVertIcon /></IconButton>}
                useLayerForClickAway={true}
                anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                targetOrigin={{horizontal: 'right', vertical: 'top'}}>
                  <MenuItem
                    primaryText={t('createCategory')}
                    onTouchTap={this.handleCategoryCreateOpen} />
                </IconMenu>
            </ToolbarGroup>
          </Toolbar>
          <CardText style={{textAlign: 'left', position: 'relative'}}>
            <SelectField
              floatingLabelText={t('category')}
              value={this.state.selectValue}
              onChange={this.handleCategoryChange}>
              {categories}
            </SelectField>
            <List>
              {products}
            </List>
            <div>
              <IconButton
                onTouchTap={() => this.getFirstProducts(this.props.user.shopkeeperId)}
                disabled={(this.state.firstPage)}>
                <FirstPage />
              </IconButton>
              <IconButton
                onTouchTap={this.getPreviousProducts}
                disabled={(this.state.firstPage)}>
                <Previous />
              </IconButton>
              <IconButton
                onTouchTap={this.getNextProducts}
                disabled={(this.state.lastPage)}>
                <Next />
              </IconButton>
              <IconButton
                onTouchTap={this.getLastProducts}
                disabled={(this.state.lastPage)}>
                <LastPage />
              </IconButton>
            </div>
          </CardText>
          <ProductCreate open={this.state.dialogCreateOpen} handleClose={this.handleCreateClose} category={this.state.category}/>
          <CategoryCreate open={this.state.dialogCategoryCreateOpen} handleClose={this.handleCategoryCreateClose}/>
      </Card>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(Portfolio);



// WEBPACK FOOTER //
// ./src/Admin/Portfolio.js